import { useTranslation } from 'react-i18next'

import cn from 'classnames'

import { Icon } from 'src/components/ui'
import { formattedText } from 'src/utils/formattedText'

import { formatDateWithMonthGenitive } from '../../utils/formatDateWithMonthGenitive'
import styles from './TransactionInfo.module.scss'

interface Props {
  className?: string
  transactionType: 'DEPOSIT' | 'TRANSFER' | 'WITHDRAWAL' | 'INVESTMENT' | 'WIN' | 'LOSE'
  createdAt: string
  amount_stars: number
  commission: number
}

export const TransactionInfo: React.FC<Props> = ({
  transactionType,
  createdAt,
  amount_stars,
  commission,
  className,
}) => {
  const { t } = useTranslation()

  const transactionCreationDate = formatDateWithMonthGenitive(createdAt, t)

  return (
    <div className={cn(className, styles.info)}>
      <div className={styles.icon}>
        <Icon name={transactionType + '_page' || ''} />
      </div>

      <p className={styles.date}>{transactionCreationDate}</p>

      <div className={styles.amount}>
        <p>{formattedText(Number(amount_stars.toFixed(3)) || 0)}</p>
        <Icon name='amount_star' />
      </div>

      <div className={styles.commission}>
        <p>{t('transaction_input.commission', { commission })}</p>
        <Icon name='commission_star' />
      </div>
    </div>
  )
}
